export default [
  {
    label: 'Razão social', field: 'razaoSocial', editable: true, evento: null, type: 'custom',
  },
  { label: 'CNPJ/CPF', field: 'cadastroFederal', tdClass: 'col-tamanho-cnpj' },
  { label: 'Inscrição estadual', field: 'inscricaoEstadual' },
  { label: 'Município/UF', field: 'municipioUf' },
  { label: 'Regime', field: 'empresaRegime' },
  {
    label: 'Certificado digital',
    field: 'certificadoVinculado',
    type: 'custom',
    visible: true,
  },
  { label: 'Inativação', field: 'inativacao', visible: false },
]
